import type { DocMigration } from "../docMigration";

interface WithSortIndex extends Record<string, unknown> {
  sortIndex: number;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_384: DocMigration = {
  maxSchemaVersion: "0.0.384",
  description: "Correct view template sort indices",
  apply(json: any) {
    // Attempt to sort the view templates by sort index
    const viewTemplates = Object.values(json.viewTemplates).sort(
      (a, b) => (a as WithSortIndex).sortIndex - (b as WithSortIndex).sortIndex,
    ) as WithSortIndex[];

    // Update the sort index of each view template, preventing two view templates from having the same sort index
    for (let i = 0; i < viewTemplates.length; i++) {
      viewTemplates[i].sortIndex = i;
    }

    return json;
  },
};

export default migration_0_0_384;
